<template>
	<vs-prompt
		@accept="shipOrderAccept"
		:active.sync="visible"
		title="SendCloud label aanmaken"
		acceptText="Verzend"
		cancelText="Annuleren">
		<form data-vv-scope="createSendCloudForm">
			<div class="vx-row">
				<div class="vx-col w-full">
					<label class="multiselect-label">Verzendmethode</label>
					<vue-multiselect
						placeholder="Selecteer verzendmethode"
						v-model="shippingMethod"
						:options="shipOptions"
						:show-labels="false"
						:allow-empty="false"
						label="text"
						track-by="value"
					/>
				</div>

				<div class="vx-col w-full">
					<vs-input
						v-validate="'required'"
						name="shippingWeight"
						:danger-text="errors.first('createSendCloudForm.shippingWeight')"
						:danger="errors.has('createSendCloudForm.shippingWeight')"
						label="Gewicht in kilo"
						v-model="shippingWeight"
						class="w-full"
					/>
				</div>
			</div>
		</form>
	</vs-prompt>
</template>

<script>

import apiClient from '@/services/apiClient';
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';
import {mapGetters} from 'vuex';

Vue.use(VeeValidate);
const messages = {
	custom: {
		shippingMethod: {
			required: 'Dit veld is verplicht',
		},
		shippingWeight: {
			required: 'Dit veld is verplicht',
		}
	}
};
Validator.localize('en', messages);

export default {
	props: {
		order: {
			type: Object,
			required: true,
		}
	},
	data() {
		return {
			visible: false,
			shippingMethod: null,
			shippingWeight: 0.050,
			shipOptions: [],
		}
	},
	computed: {
		...mapGetters({
			shippingOptions: 'sendCloud/shippingOptions'
		})
	},
	mounted() {
		if (this.shippingOptions !== null && this.shippingOptions.length > 0) {
			for (const shippingOption in this.shippingOptions) {
				if (this.shippingOptions.hasOwnProperty(shippingOption)) {
					if (this.shippingOptions[shippingOption] && this.shippingOptions[shippingOption].enabled) {
						this.shipOptions.push({
							text: this.shippingOptions[shippingOption].shipping_option.name,
							value: this.shippingOptions[shippingOption].shipping_option.id
						})
					}
				}
			}
		}
	},
	methods: {
		shipOrderAccept() {
			this.$validator.validateAll('createSendCloudForm').then(result => {
				if (!result) {
					this.visible = true;

					this.$vs.notify({
						title: 'Oops!',
						text: 'Er zitten fouten in het formulier.',
						color: 'danger'
					});

					return;
				}

				const params = {
					order_id: this.order.order.id,
					shipping_method: this.shippingMethod.value,
					weight: this.shippingWeight,
				};

				apiClient.post('orders/ship/sendcloud/label', params).then(response => {
					this.$store.dispatch('openOrdersStore/updateOrder', response.data);
				}).catch(error => {
					this.$vs.notify({
						title: 'Oops!',
						text: 'Het aanmaken van SendCloud label van bestelling #' + this.order.order.type_id_visible + ' is mislukt',
						color: 'danger'
					});
				})
			});
		}
	}
}
</script>